export const TagsKey = 'tags';